import { call, put, takeEvery, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { UPDATE_LOGO_REQUEST } from '../constants/logoConstants';
import { updateLogoSuccess, updateLogoFailure } from '../actions/logoActions';
import { updateLogoApi } from '../api/logoApi';
import { getProfileRequest } from '../actions/profileActions';

function* updateLogoSaga(action) {
  try {
    const response = yield call(updateLogoApi, action.payload);
    yield put(updateLogoSuccess(response));
    
    toast.success(response.message || 'Logo updated successfully');
    
    // Fetch updated OEM partner data
    const user = yield select(state => state.auth.user);
    if (user?.oemPartner?._id) {
      yield put(getProfileRequest(user.oemPartner._id));
    }
  } catch (error) {
    yield put(updateLogoFailure(error.message));
    toast.error(error.message || 'Logo update failed');
  }
}

function* logoSaga() {
  yield takeEvery(UPDATE_LOGO_REQUEST, updateLogoSaga);
}

export default logoSaga;